<div [formGroup]="userPreferredLanguageForm" class="form flex flex-col">
  <nx-edit-select-input
    formControlName="preferredLanguage"
      [options]="languageOptions"
      [label]="'core.user.preferredLanguageDialog.formControls.preferredLanguage.label' | translate">
  </nx-edit-select-input>
<div>